import { render, staticRenderFns } from "./downqrcodePopup.vue?vue&type=template&id=653b45fd&scoped=true&"
import script from "./downqrcodePopup.vue?vue&type=script&lang=js&"
export * from "./downqrcodePopup.vue?vue&type=script&lang=js&"
import style0 from "./downqrcodePopup.vue?vue&type=style&index=0&id=653b45fd&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "653b45fd",
  null
  
)

export default component.exports